
import AmountIncrease from "../../../../../components/amountIncrease";
import DeleteButton from "../../../../../components/deleteButton";
import { getInstrument } from "../../../../../data/instrumentManager";
import { InstrumentAmountDTOInstrumentEnum } from "../../../../../openapi-generated-client";
import "./editPieceInstrumentElement.css";

interface EditPieceInstrumentElementProps {
    amount: number;
    setAmount: (v: number) => void;
    instrument: InstrumentAmountDTOInstrumentEnum;
    onDelete: () => void;
    notRemoveable?: boolean;
}

export default function EditPieceInstrumentElement(props: EditPieceInstrumentElementProps) {
    var instrument = getInstrument(props.instrument);
    if(instrument == undefined) {
        return <div className="instrument-element">
            <a>Unknown instrument</a>
        </div>;
    }
    return <div className="instrument-element">
        {instrument.icon}
        <a>{instrument.name}</a>
        <AmountIncrease amount={props.amount} onChange={(v: number) => {
            if(v == 0 && props.notRemoveable) return;
            props.setAmount(v);
        }
        }/>
        <DeleteButton disabled={props.notRemoveable} onDelete={props.onDelete}/>
    </div>;
}